/**
 * Typography used in theme
 * @param {JsonObject} theme theme customization object
 */

export default function themeTypography(theme) {
    return {
        fontFamily: "Montserrat",
        h6: {
            fontWeight: 500,
            color: theme.colors.secondaryMain,
        },
        h5: {
            fontWeight: 500,
        },
        h4: {
            fontWeight: 600,
        },
        h3: {
            fontWeight: 600,
        },
        h2: {
            fontWeight: 700,
        },
        h1: {
            fontWeight: 700,
        },
        subtitle1: {
            fontWeight: 500,
        },
        subtitle2: {
            fontWeight: 400,
            color: theme.darkTextSecondary,
        },
        caption: {
            color: theme.darkTextSecondary,
            fontWeight: 400,
        },
        body1: {
            fontWeight: 400,
        },
        body2: {
            fontWeight: 400,
            color: theme.darkTextPrimary,
        },
        button: {
            textTransform: "uppercase",
            letterSpacing: 0.5,
            fontWeight: 600,
        },
        customInput: {
            marginTop: 1,
            marginBottom: 1,
            "& > label": {
                top: 23,
                left: 0,
                color: theme.grey500,
                '&[data-shrink="false"]': {
                    top: 5,
                },
            },
            "& > div > input": {
                padding: "30.5px 14px 11.5px !important",
            },
            "& legend": {
                display: "none",
            },
            "& fieldset": {
                top: 0,
            },
        },
        mainContent: {
            backgroundColor: theme.background,
            width: "100%",
            minHeight: "100vh",
            flexGrow: 1,
            padding: 15,
            margin: "auto",
            borderRadius: "18px",
        },
        menuCaption: {
            //fontSize: "0.875rem",
            fontWeight: 500,
            //color: theme.heading,
            padding: "6px",
            textTransform: "capitalize",
            marginTop: "10px",
        },
        subMenuCaption: {
            //fontSize: "0.6875rem",
            fontWeight: 500,
            //color: theme.darkTextSecondary,
            textTransform: "capitalize",
        },
        commonAvatar: {
            cursor: "pointer",
            borderRadius: "8px",
        },
        smallAvatar: {
            width: "22px",
            height: "22px",
            fontSize: "1rem",
        },
        mediumAvatar: {
            width: "34px",
            height: "34px",
            fontSize: "1.2rem",
        },
        largeAvatar: {
            width: "44px",
            height: "44px",
            fontSize: "1.5rem",
        },
    };
}
